/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const DOWNLOAD_TO_BOTTOM_PATH =
  'M15 18H1C0.734784 18 0.48043 18.1054 0.292893 18.2929C0.105357 18.4804 0 18.7348 0 19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20H15C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19C16 18.7348 15.8946 18.4804 15.7071 18.2929C15.5196 18.1054 15.2652 18 15 18ZM7.29 15.71C7.3851 15.801 7.49725 15.8724 7.62 15.92C7.7397 15.9729 7.86913 16.0002 8 16.0002C8.13087 16.0002 8.2603 15.9729 8.38 15.92C8.50275 15.8724 8.6149 15.801 8.71 15.71L12.71 11.71C12.8983 11.5217 13.0041 11.2663 13.0041 11C13.0041 10.7337 12.8983 10.4783 12.71 10.29C12.5217 10.1017 12.2663 9.99591 12 9.99591C11.7337 9.99591 11.4783 10.1017 11.29 10.29L9 12.59V1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0C7.73478 0 7.48043 0.105357 7.29289 0.292893C7.10536 0.48043 7 0.734784 7 1V12.59L4.71 10.29C4.61676 10.1968 4.50607 10.1228 4.38425 10.0723C4.26243 10.0219 4.13186 9.99591 4 9.99591C3.86814 9.99591 3.73757 10.0219 3.61575 10.0723C3.49393 10.1228 3.38324 10.1968 3.29 10.29C3.19676 10.3832 3.1228 10.4939 3.07234 10.6158C3.02188 10.7376 2.99591 10.8681 2.99591 11C2.99591 11.1319 3.02188 11.2624 3.07234 11.3842C3.1228 11.5061 3.19676 11.6168 3.29 11.71L7.29 15.71Z';

/* Figma asset: 16×20 viewBox */
const VIEWBOX_W = 16;
const VIEWBOX_H = 20;

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Download-to-bottom / save-to-disk (16×20 asset).
 * Color via `currentColor` — set via CSS `color` property or `ds-icon--color-*` utility.
 * Pass `aria-label` when the icon conveys meaning without adjacent visible text.
 */
const DownloadToBottomIcon = ({
  size = 20,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const width = size;
  const height = Math.round((size * VIEWBOX_H) / VIEWBOX_W);

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path d={DOWNLOAD_TO_BOTTOM_PATH} fill="currentColor" />
    </svg>
  );
};

DownloadToBottomIcon.propTypes = iconPropTypes;

export { DownloadToBottomIcon };
export default DownloadToBottomIcon;
